import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "../redux-store/store";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, toast } from "react-toastify";

// CSS
import "./css/wizard-menu.css";

// Pages
import Brand from "./pages/Brand";
import Store from "./pages/Store";
import Account from "./pages/Account";
import Success from "./pages/Success";

const logo = `${EASYCOMMERCE.assets}common/img/logo.svg`;
const check = `${EASYCOMMERCE.assets}admin/img/icons/check.png`;

const tabs = ["/brand", "/store", "/account", "/success"];
const defaultTab = tabs[0];

const App = () => {
    const formData = useSelector((state) => state.formData);
    const [activeTab, setActiveTab] = useState(
        window.location.hash.replace("#", "") || defaultTab
    );
    const [isAPIKeyVisible, setIsAPIKeyVisible] = useState(false);

    const showToast = (type, message) => {
        toast[type](message, {
            position: "top-right",
            style: {
                margin: "30px 0 0 0",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "26px",
                color: "#fff",
            },
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    useEffect(() => {
        const handleHashChange = () => {
            const newHash = window.location.hash.replace("#", "");
            if (tabs.includes(newHash)) {
                setActiveTab(newHash);
            } else {
                setActiveTab(defaultTab);
                window.location.hash = defaultTab;
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();

        return () => {
            window.removeEventListener("hashchange", handleHashChange);
        };
    }, []);

    const saveDataToAPI = () => {
        if (activeTab === "/brand") {
            fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                },
                body: JSON.stringify({
                    data: {
                        type: "brand",
                        logo: formData.logo,
                        store_name: formData.store_name,
                        business_type: formData.business_type,
                    },
                }),
            });
            
        } else if (activeTab === "/store") {
            fetch(`${EASYCOMMERCE.rest_base}/connectivity/setup/save`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                },
                body: JSON.stringify({
                    data: {
                        type: "store",
                        currency: formData.currency,
                        active_methods:
                            formData.payment_methods.length > 0
                                ? formData.payment_methods.length === 1
                                    ? formData.payment_methods[0]
                                    : formData.payment_methods
                                : "",
                        shop: formData.shop,
                        checkout: formData.checkout,
                        dashboard: formData.dashboard,
                        import_demo: formData.import_demo,
                    },
                }),
            });

        } else if (
            activeTab === "/account" &&
            formData.email &&
            formData.apiKey
        ) {
            easycommerce_modal(true);
            fetch(`${EASYCOMMERCE.rest_base}/connectivity/token/verify`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": EASYCOMMERCE.nonce,
                },
                body: JSON.stringify({
                    email: formData.email,
                    token: formData.apiKey,
                }),
            })
            .then(response => response.json())
                .then(data => {
                    easycommerce_modal(false);
                    if (data.success && data.data?.verified) {
                        showToast("success", "API Key Verified Successfully");
                    } else {
                        showToast("error", "API Key verification failed");
                    }
                })
                .catch(() => {
                    showToast("error", "Something went wrong");
            });
        }
    };
    const handleNext = () => {
        const currentIndex = tabs.indexOf(activeTab);

        if (activeTab === "/account") {
            if (!isAPIKeyVisible) {
                easycommerce_modal(true);
                fetch(`${EASYCOMMERCE.rest_base}/connectivity/token`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-WP-Nonce": EASYCOMMERCE.nonce,
                    },
                    body: JSON.stringify({
                        name: formData.name,
                        email: formData.email,
                    }),
                })
                .then(response => response.json())
                    .then(data => {
                        setTimeout(() => {
                            easycommerce_modal(false);
                            if (data.success) {
                                setIsAPIKeyVisible(true);
                                showToast("success","API Key Sent to your email");
                            } else {
                                showToast("error", "Failed to send API key");
                            }
                        }, 1000);
                    })
                    .catch(() => {
                        showToast("error", "Something went wrong");
                });
                
            } else {
                if (currentIndex < tabs.length - 1) {
                    if (
                        activeTab === "/account" &&
                        formData.email &&
                        formData.apiKey
                    ) {
                        easycommerce_modal(true);
                        fetch(`${EASYCOMMERCE.rest_base}/connectivity/token/verify`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-WP-Nonce": EASYCOMMERCE.nonce,
                            },
                            body: JSON.stringify({
                                email: formData.email,
                                token: formData.apiKey,
                            }),
                        })
                        .then(response => response.json())
                            .then(data => {
                                easycommerce_modal(false);
                                if (data.success && data.data?.verified) {
                                    showToast("success", "API Key Verified Successfully");
                                    const nextTab = tabs[currentIndex + 1];
                                    setActiveTab(nextTab);
                                    window.location.hash = nextTab;
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                } else {
                                    showToast("error", "API Key verification failed");
                                }
                            })
                            .catch(() => {
                                easycommerce_modal(false);
                                showToast("error", "Something went wrong");
                        });
                    }
                }
            }
        } else {
            if (currentIndex < tabs.length - 1) {
                const nextTab = tabs[currentIndex + 1];
                setActiveTab(nextTab);
                window.location.hash = nextTab;
                window.scrollTo({ top: 0, behavior: "smooth" });

                saveDataToAPI(); 
            }
        }
    };

    
    const handlePrevious = () => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex > 0) {
            const prevTab = tabs[currentIndex - 1];
            setActiveTab(prevTab);
            window.location.hash = prevTab;
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const handleSkip = () => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex < tabs.length - 1) {
            const nextTab = tabs[currentIndex + 1];
            setActiveTab(nextTab);
            window.location.hash = nextTab;
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const getStepClassName = (index) => {
        const currentIndex = tabs.indexOf(activeTab);
        if (currentIndex > index) {
            return "bg-ec-primary text-white";
        } else if (currentIndex === index) {
            return "bg-ec-primary text-white";
        } else {
            return "border-2 border-[#E0E8FF] text-ec-secondary bg-[#EEF2FF]";
        }
    };

    const progressWidth = `${
        (tabs.indexOf(activeTab) / (tabs.length - 1)) * 95
    }%`;

    return (
        <div
            className={`bg-[#EEF2FF] ${
                activeTab === "/account" && "h-screen"
            } flex justify-center items-center`}
        >
            <div className="w-full h-full flex flex-col items-center">
                {activeTab !== "/success" && (
                    <>
                        <div className="flex justify-center py-[60px] w-[40%]">
                            <img
                                src={logo}
                                alt="logo"
                                className="h-[44px] w-[211px] pointer-events-none"
                            />
                        </div>
                        <div className="relative flex flex-col items-center mb-8  w-[40%]">
                            <div className="relative w-full">
                                <div className="absolute top-[18px] left-0 right-0 h-[3px] bg-[#E0E8FF] z-0 mx-4"></div>
                                <div
                                    className="absolute top-[18px] left-0 h-1 bg-gradient-to-r from-ec-primary to-[#3DE8FF] transition-all duration-1000 z-10 mx-4"
                                    style={{ width: progressWidth }}
                                ></div>
                                <div className="flex justify-between">
                                    {tabs.map((tab, index) => (
                                        <div
                                            key={index}
                                            className="relative z-10 flex flex-col items-center"
                                        >
                                            {activeTab === tab ? (
                                                <div className="relative top-[-7px]">
                                                    <div className=" bg-[#EEF2FF] border-4 border-black/10 border-l-ec-primary border-r-ec-primary border-b-ec-primary rounded-full w-[55px] h-[55px] animate-[donut-spin_4s_linear_infinite]"></div>
                                                    <div
                                                        className={`rounded-full w-10 h-10 flex items-center p-[9px] text-[16px] justify-center bg-ec-primary text-white absolute top-[8px] right-[8px]`}
                                                    >
                                                        {index + 1}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    className={`rounded-full w-10 h-10 flex items-center p-[9px] text-[16px] justify-center ${getStepClassName(
                                                        index
                                                    )}`}
                                                >
                                                    {tabs.indexOf(activeTab) >
                                                    index ? (
                                                        <img
                                                            src={check}
                                                            alt="check-icon"
                                                            className="w-[18px]"
                                                        />
                                                    ) : (
                                                        index + 1
                                                    )}
                                                </div>
                                            )}
                                            <div
                                                className={`text-center text-[16px] text-ec-secondary capitalize ${
                                                    activeTab === tab
                                                        ? "font-bold text-ec-body"
                                                        : "mt-2 "
                                                }`}
                                            >
                                                {tab.replace("/", "")}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {["/brand", "/store", "/account"].includes(activeTab) && (
                    <div className="mb-24 w-full">
                        {activeTab === "/brand" && <Brand />}
                        {activeTab === "/store" && <Store />}
                        {activeTab === "/account" && <Account isAPIKeyVisible={isAPIKeyVisible} />}

                        <div className="w-[40%] mt-6 mx-auto flex justify-between items-center gap-4">
                            <div>
                                {activeTab !== defaultTab &&
                                    activeTab !== tabs[tabs.length - 1] && (
                                        <button
                                            onClick={handlePrevious}
                                            className="w-[120px] h-12 bg-transparent font-inter font-normal 
                                            text-ec-primary hover:text-white text-base leading-[26px] border 
                                            border-ec-primary rounded-lg focus:shadow-none hover:bg-ec-primary 
                                            transition-all ease-in-out duration-300"
                                        >
                                            Previous
                                        </button>
                                    )}
                            </div>

                            <div className="flex justify-end items-center gap-8">
                                <button
                                    className="w-[80px] h-12 font-inter font-normal text-base leading-[26px]
                                    text-ec-secondary hover:text-ec-body focus:text-ec-body transition-all
                                    ease-in-out duration-300"
                                    onClick={handleSkip}
                                >
                                    Skip
                                </button>
                                {activeTab !== tabs[tabs.length - 1] && (
                                    <button
                                        onClick={handleNext}
                                        className="w-[120px] h-12 font-inter bg-ec-primary group border border-ec-primary 
                                        rounded-lg text-white font-normal hover:text-white hover:bg-ec-secondary 
                                        focus:shadow-none lg:text-base md:text-xs sm:text-sm transition-all ease-in-out 
                                        duration-300 leading-[26px]"
                                    >
                                        Next
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {activeTab === "/success" && (
                    <div className="w-full h-screen">
                        <Success/>
                    </div>
                )}
            </div>
            <ToastContainer />
        </div>
    );
};
const container = document.getElementById("easycommerce_wizard_render");
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
